import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { fileSystemApiToEntity } from '../../entities/FileSystem';
import { BaseClient } from '../BaseClient';
import { encodeFieldMaskPath } from './fieldMask';
const FOLDERS = ['knowledge', 'brain', 'scheduler', 'pulse'];
const RETRY_LIMIT = 3;
export class FileSystemClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getFileSystemImpl", void 0);
    _defineProperty(this, "updateFileSystemImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'FileSystemClient';
  }
  async getFileSystem() {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const {
        fileSystem
      } = await this.request(this.getFileSystemImpl({}), ...args);
      if (!fileSystem) {
        throw new Error('FileSystem missing in response');
      }
      return this.convertToEntity(fileSystem);
    } catch (error) {
      this.logError('getFileSystem', 'Failed to get FileSystem', {}, error);
      throw error;
    }
  }
  async updateFileSystem(patch) {
    let lastError;
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    for (let attempt = 0; attempt < RETRY_LIMIT; attempt++) {
      const current = await this.getFileSystem(...args);
      const {
        fileSystem,
        fieldMask
      } = this.buildUpdatePayload(current, patch);
      if (fieldMask.length === 0) {
        return current; // Nothing to do.
      }
      try {
        const {
          fileSystem: updated
        } = await this.request(this.updateFileSystemImpl({
          fileSystem,
          fieldMask
        }), ...args);
        if (!updated) {
          throw new Error('FileSystem missing in update response');
        }
        return this.convertToEntity(updated);
      } catch (error) {
        if (!this.isRevisionMismatch(error) || attempt === RETRY_LIMIT - 1) {
          this.logError('updateFileSystem', 'Failed to update FileSystem', {
            attempt
          }, error);
          throw error;
        }
        lastError = error;
        await this.sleepJittered();
      }
    }
    throw lastError;
  }
  buildUpdatePayload(current, patch) {
    const merged = {
      knowledge: {
        ...current.knowledge
      },
      brain: {
        ...current.brain
      },
      scheduler: {
        ...current.scheduler
      },
      pulse: {
        ...current.pulse
      }
    };
    const fieldMask = [];
    for (const folder of FOLDERS) {
      const folderPatch = patch[folder];
      if (!folderPatch) {
        continue;
      }
      for (const [key, value] of Object.entries(folderPatch)) {
        if (value === undefined) {
          Reflect.deleteProperty(merged[folder], key);
        } else {
          merged[folder][key] = value;
        }
        fieldMask.push(encodeFieldMaskPath(folder, key));
      }
    }
    return {
      fileSystem: {
        revision: current.revision,
        knowledge: merged.knowledge,
        brain: merged.brain,
        scheduler: merged.scheduler,
        pulse: merged.pulse
      },
      fieldMask
    };
  }
  isRevisionMismatch(error) {
    // gRPC FAILED_PRECONDITION (code 9) is what SDL emits on optimistic-concurrency conflict.
    // If staging shows a different shape, refine here — never substring-match the message.
    return Boolean(error && typeof error === 'object' && error.code === 9);
  }
  sleepJittered() {
    const ms = 50 + Math.random() * 100;
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  convertToEntity(api) {
    return fileSystemApiToEntity(api);
  }
}
//# sourceMappingURL=FileSystemClientBase.js.map